// extracted by mini-css-extract-plugin
module.exports = {"box":"PageBox_box__1Qo1t","back":"PageBox_back__kDKZR","left":"PageBox_left__33rAB"};